export const OOO_ROOM_LOCAL = 'OOOROOM';

export const OOS_ROOM_LOCAL = 'OOSROOM';

export const FLOORS_LOCAL = 'FLOORS';

export const HOTEL_LOCAL = 'HOTEL';

export const LIST_MDI_PARENT_LOCAL = 'LIST_MDI_PARENT';

export const MDI_PARENT_LOCAL = 'MDI_PARENT';

export const GI_BASIC_INFO_LOCAL = 'GI_BASICINFO';

export const MA_GIA_PHONG_LOCAL = 'MAGIAPHONG';

export const SYSTEM_PARAMETER_LOCAL = 'SYSTEMPARAMETER';

export const BOOKING_STATIC_DATA_LOCAL = 'STATIC_BOOKING_DATA';

export const COMPANY_DATA_LOCAL = 'COMPANY_LIST';

export const BO_PHAN_LOCAL = 'LST_BOPHAN';

export const DEPARMENT_LOCAL = 'DEPARMENT';

export const LOG_HISTORY_SCREEN_ROLE = 'SCREEN_ROLE';

export const LOG_HISTORY_ACTION = 'DATA_ACTION';

export const LAYOUT_SETTING = {
  INVENTORY: 'INVENTORY_LAYOUT_SETTINGS',
};

export const LOCAL_PERMISSION_USER = 'PERMISSION-USER';

export const LOCAL_LANGUAGE = 'language';

export const LOCAL_TIMEZONE = 'timezone';

export const AUTH_INFO = 'authInfo';

// Token đăng nhập chủ đầu tư (DiOwner) — phát bởi POST /auth/owner-login, mang claim HotelID.
export const OWNER_TOKEN = 'ownerToken';

// Hạn của token owner (ISO string, lấy từ `expiresAt` của owner-login — token hạn 24h).
// Dùng để tự đăng xuất khi hết hạn mà KHÔNG cần chờ backend trả 401.
export const OWNER_TOKEN_EXPIRES_AT = 'ownerTokenExpiresAt';
